import React from 'react'
import clsx from 'clsx'
import { categoryTaxonomyProps } from '../../../types'
import style from './style.module.scss'

type heroSlideTitleProps = {
    className?: string
    title: string
    link: string
    parentTax: categoryTaxonomyProps | null
    tax: categoryTaxonomyProps | null
}

export const HeroSlideTitle: React.FC<heroSlideTitleProps> = ({
    className,
    title,
    parentTax,
    tax,
    link,
}) => {
    return (
        <div className={clsx(style.content, className)}>
            <div className={style.taxs}>
                {parentTax && (
                    <>
                        <a href={parentTax.link}>{parentTax.name}</a>
                        <span>/</span>
                    </>
                )}
                {tax && <a href={tax.link}>{tax.name}</a>}
            </div>

            <h1 className={style.title}>
                <a href={link}>{title}</a>
            </h1>
        </div>
    )
}
